import { createContext, useContext, useReducer } from "react";
import { outboundReducer } from "./reducer";

const initState = {
  outboundShipments: [],
  currentInventory: {},
  currentShipment: {},
  isSourceRailcarValidated: false,
  isTargetRailcarValidated: false,
  mode: "LIST_SHIPMENTS",
  yardSignatureImg: "",
  carrierSignatureImg: "",
  errors: {},
  notes: {},
  loading: false,
};

const OutboundContext = createContext(initState);

export const OutboundProvider = ({ children }) => {
  const [state, dispatch] = useReducer(outboundReducer, initState);

  return (
    <OutboundContext.Provider value={{ state, dispatch }}>
      {children}
    </OutboundContext.Provider>
  );
};

export const useOutboundContext = () => useContext(OutboundContext);
